import { render, staticRenderFns } from "./ReportsLectorsItem.vue?vue&type=template&id=7cd6cede&scoped=true&"
import script from "./ReportsLectorsItem.vue?vue&type=script&lang=js&"
export * from "./ReportsLectorsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd6cede",
  null
  
)

export default component.exports